<template>
  <section
    v-show="filteredTodos.length"
    class="main"
  >
    <input
      :checked="allDone"
      @change="setAllCompleted($event.target.checked)"
      class="toggle-all"
      type="checkbox"
    >
    <ul class="todo-list">
      <TodoItem
        v-for="todo in filteredTodos"
        :key="todo.id"
        :title="todo.title"
        :completed="todo.completed"
        @reopen="reopenTodo(todo.id)"
        @complete="completeTodo(todo.id)"
        @remove="removeTodo(todo.id)"
        @update:title="updateTodoTitle({id: todo.id, newTitle: $event})"
      />
    </ul>
  </section>
</template>

<script>
import TodoItem from "./TodoItem.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    TodoItem
  },
  computed: {
    ...mapGetters("todoList", ["filteredTodos", "allDone"])
  },
  methods: {
    ...mapActions("todoList", [
      "setAllCompleted",
      "reopenTodo",
      "completeTodo",
      "removeTodo",
      "updateTodoTitle"
    ])
  }
};
</script>
